import { render } from "./ProfitImg.vue?vue&type=template&id=3df0b2ac"
import script from "./ProfitImg.vue?vue&type=script&lang=js"
export * from "./ProfitImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__